import React, { useEffect, useState } from "react";
import * as cls from "./restore.module.scss";
import authImg from "../../resources/images/authorization.png";
import { useDispatch, useSelector } from "react-redux";
import {
  assignAction,
  authErrorAction,
  changeStepAction,
  setTokenAction,
} from "../../redux/actions/actions";
import { useNavigate } from "react-router-dom";
import Reload from "../../resources/icons/Reload";
import { AuthorizationService } from "../authorizationService";
import { Icon } from "../../../personal-studio-components/frame";
import { Button } from "../../../personal-studio-components/form";
import PolicyFooter from "../policyFooter/PolicyFooter";

export default function Restore({
  setCurrpage,
  setStep,
  step,
  paramsToken,
  signUpVideoGuide,
}) {
  const [email, setEmail] = useState("");
  const [captchaUrl, setCaptchaUrl] = useState(null);
  const [captchaUuid, setCaptchaUuid] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");
  const [paswdVisible, setPaswdVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function failed(data) {
    const err = data;
    const errorEvent = new ErrorEvent("error", {
      error: err,
    });
    window.dispatchEvent(errorEvent);
    dispatch(authErrorAction(true));
  }
  const onKeyUp = (event) => {
    if (event.code === "NumpadEnter" || event.code === "Enter") {
      switch (step) {
        case 0:
          handleGetCaptcha();
          break;
        case 1:
          handleSendCaptcha();
          break;
        case 3:
          restoreConfirm();
      }
    }
  };
  const handleGetCaptcha = async () => {
    const request = {
      method: "post",
      path: "/password/restore/captcha",
      data: {
        email,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});
    if (data.errors) {
      failed(data);
      return;
    }
    const { captcha_url, captcha_uuid } = data;
    setCaptchaUrl(captcha_url);
    setCaptchaUuid(captcha_uuid);
    // setStep(1);
    dispatch(changeStepAction(1));
  };

  const handleSendCaptcha = async () => {
    const request = {
      method: "post",
      path: "/password/restore/request",
      data: {
        email: email,
        captcha_uuid: captchaUuid,
        captcha_data: inputValue,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});
    if (data.errors) {
      // failed(data);
      setCaptchaErrorMessage(data.errors[0] + " Повторите попытку");
      handleGetCaptcha();
      return;
    }
    // setStep(2);
    dispatch(changeStepAction(2));
  };
  const restoreConfirm = async () => {
    const request = {
      method: "post",
      path: "/password/restore/confirm",
      data: {
        token: paramsToken,
        new_password: newPassword,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});
    // const data = {
    //   error_type: "other",
    //   errors: ["Ошибка11"],
    //   http_error: 400,
    // };
    if (data.errors) {
      failed(data);
      return;
    }
    if (data.status === "updated") {
      // setStep(4);
      dispatch(changeStepAction(4));

      dispatch(assignAction({ password: newPassword }));
      return;
    }
    localStorage.setItem(
      "personalStudioAccessToken",
      JSON.stringify(data.access_token),
    );
    localStorage.setItem(
      "personalStudioRefreshToken",
      JSON.stringify(data.refresh_token),
    );
    navigate("/");
    dispatch(setTokenAction(data));
  };
  return (
    <div className={cls.root}>
      <div className={cls.imgContainer}>
        <img src={authImg} />
      </div>
      <div className={cls.logWrapper}>
        <div className={cls.logContainer} onKeyUp={onKeyUp}>
          <div className={cls.header}>
            {step === 2 &&
              "На указанную электронную почту была отправлена ссылка для входа"}
            {step < 2 &&
              "Введите адрес электронной почты, указанный при регистрации"}
            {step === 3 && "Придумайте новый пароль"}
            {step === 4 && "Пароль успешно обновлен"}
          </div>
          <div className={cls.body}>
            {step === 3 && (
              <div className={cls.password}>
                <span className={cls.gray_text}>Придумайте новый пароль</span>
                <input
                  autoFocus
                  autoComplete="off"
                  value={newPassword}
                  onChange={(event) => setNewPassword(event.target.value)}
                  placeholder="Введите новый пароль"
                  type={paswdVisible ? "" : "password"}
                />
                <div
                  className={cls.password_control}
                  onClick={() => setPaswdVisible((prev) => !prev)}
                >
                  <Icon
                    name={paswdVisible ? "eye_invisible" : "eye_visible"}
                    className={cls.icon}
                  />
                </div>
              </div>
            )}
            {step < 2 && (
              <div className={cls.login}>
                <span className={cls.gray_text}>Логин</span>
                <input
                  autoFocus
                  autoComplete="off"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Введите свой логин"
                />
              </div>
            )}
          </div>
          {step === 1 && captchaUrl && (
            <div className={cls.captchaContainer}>
              <div className={cls.imgContainer}>
                <img className={cls.img} src={captchaUrl} alt="" />
                <div
                  onClick={handleGetCaptcha}
                  className={cls.reload}
                  title="Получить новую капчу"
                >
                  <Reload />
                </div>
              </div>
              <div className={cls.login}>
                <span className={cls.gray_text}>Введите текст из капчи</span>
                <span className={cls.invalid_captcha}>
                  {captchaErrorMessage}
                </span>
                <input
                  autoFocus
                  autoComplete="off"
                  value={inputValue}
                  placeholder="Введите текст из капчи"
                  onChange={(event) => setInputValue(event.target.value)}
                />
              </div>
            </div>
          )}
          <div className={cls.btnContainer}>
            {/* <div className={cls.signPrimary}> */}
            {/* {step === 0 && <button onClick={handleGetCaptcha}>Далее</button>} */}
            {step === 0 && (
              <Button onClick={handleGetCaptcha} type="primary">
                Далее
              </Button>
            )}

            {/* {step === 1 && (
              <button onClick={handleSendCaptcha}>Подтвердить</button>
            )} */}
            {step === 1 && (
              <Button onClick={handleSendCaptcha} type="primary">
                Подтвердить
              </Button>
            )}
            {/* {step === 3 && <button onClick={restoreConfirm}>Сменить</button>} */}
            {step === 3 && (
              <Button onClick={restoreConfirm} type="primary">
                Сменить
              </Button>
            )}

            {/* </div> */}
            {(step === 0 || step === 4) && (
              <Button onClick={() => setCurrpage("signIn")}>Войти</Button>

              // <div className={cls.signSecondary}>
              //   <button onClick={() => setCurrpage("signIn")}>Войти</button>
              // </div>
            )}
          </div>
          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <a
              href={signUpVideoGuide}
              target="_blank"
              rel="noopener noreferrer"
            >
              Видеоинструкция по регистрации в Личном кабинете обучающегося
            </a>
          </div>
        </div>
        <div className={cls.policyFooter}>
          <PolicyFooter />
        </div>
      </div>
    </div>
  );
}
